import { render, staticRenderFns } from "./logoutHeader.vue?vue&type=template&id=e2ef5f0e&scoped=true&"
import script from "./logoutHeader.vue?vue&type=script&lang=js&"
export * from "./logoutHeader.vue?vue&type=script&lang=js&"
import style0 from "./logoutHeader.vue?vue&type=style&index=0&id=e2ef5f0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2ef5f0e",
  null
  
)

export default component.exports